import React from "react"
import { APIResponse } from "redux/apis/types"
import APIs from "redux/apis"
import uuid from "uuid"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { PAGE_NUM } from "config/const"

type Props = {
  setData: Function
  today?: boolean
  page?: number
}

type LabelList = {
  id: string | number
  name: string
  title: string
}

export const label: Array<LabelList> = [
  { id: 0, name: "国内株", title: "決算カレンダー" },
  { id: 1, name: "外国株", title: "決算発表実績一覧" },
]

export const defaultTargetExchange =
  "101,102,2011,2021,2022,2031,2041,2042,2051,2061,2071,2081,2091,2101,2102,2111,2121"

export const calenderApi = async (props: Props) => {
  const loadResistId = uuid()
  store.dispatch(pageLoadRegist(loadResistId, true))
  const profitAnnouncementCalendar: APIResponse.Res = await APIs.News.GetProfitAnnouncementCalendar(
    { TodayOnly: !!props.today }
  )
  props.setData(profitAnnouncementCalendar)
  store.dispatch(pageLoadRegist(loadResistId, false))
}
export const foreignCalenderApi = async (props: Props) => {
  const EquityCloseDayList: APIResponse.Res = await APIs.News.EquityCloseDayList(
    {
      TargetExchanges: defaultTargetExchange,
      DayBefore: 90,
      _take: PAGE_NUM.PAGE_20,
      _skip: props.page * PAGE_NUM.PAGE_20,
    }
  )
  props.setData(EquityCloseDayList)
}
